import styled from "styled-components"
import ReactLoading from 'react-loading';

interface IButton {
  name: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset"; // Tipos de botão válidos
  status: boolean
}

export default function ActionButtonLoad({ name, onClick, type = "button", status=false}: IButton) {
  return (
    <Container>
      <ButtonAction
        type={type}
        onClick={onClick}
        disabled={status}
        className={status ? "loading" : ""}>
        {
          status ? (
            <p>
              <ReactLoading type="spokes" color="white" height="20px" width="20px" />
              {name}
            </p>
          )
            :
            <p>{name}</p>

        }
      </ButtonAction>
    </Container >
  )
}

const Container = styled.div`
  width: 100%;
`;

const ButtonAction = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  padding: 10px 16px;
  
  font-weight: 500;
  font-size: 16px;
  &.loading{
    background-color: ${(props) => props.theme.colors.red.red_800};
  }
  p{
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &:hover{
      background-color: ${(props) => props.theme.colors.red.red_800};
  }
`;